import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FullScreenLoader from 'components/FullScreenLoader';
import cn from 'classnames';
import renderIf from 'render-if';

import styles from './CoachApplication.scss';
import Error from '../ErrorMessage/Error';

const Application = (props) => {
  if (props.item.get('application_status') === 'VERIFIED') {
    return null;
  }
  return (
    <div
      className={props.item.get('college_id') !== undefined ? cn('col s12', styles.listContainer)
      : cn('col s12', styles.listContainerWithoutBottomPadding)}
    >
      <button className={styles.deleteButton} onClick={props.deleteCoachApplication} >
        <img src="https://media.dev.myrecruitboard.com/Images/deleteicon.png" alt="delete-icon" />
      </button>
      <div className={cn('col s12 m2', styles.profileImage)}>
        <img alt="profile_icon" src="https://media.dev.myrecruitboard.com/Images/coachIcon.png" />
      </div>
      <div className={cn('col s12 m7', styles.infoContainer)}>
        <div className={cn('col s12 m6', styles.infoContainer)}>
          <span>
            <pp className={styles.lightText}> {props.item.get('name')}</pp><br />
            <pp className={styles.lightText}> {props.item.get('college')}</pp><br />
            <pp className={styles.lightText}> {props.item.get('city')},{props.item.get('state')}</pp><br />
          </span>
        </div>
        <div className={cn('col s12 m6', styles.infoContainer)}>
          <span>
            <pp className={styles.lightText}> {props.item.get('coach_email')}</pp><br />
          </span>
        </div>
      </div>
      <div className={cn('col s12 m3', styles.buttonContainer)}>
        <span>
          {props.item.get('college_id') !== undefined ?
            <button onClick={() => props.handleApplicationUpgrade(props.item.get('coach_id'))}>verify</button>
            : '' }
        </span>
      </div>
      <div className={cn('col 12')} >
        {props.item.get('college_id') === undefined ?
          <div className={styles.troubleFindingClassNameMondayMorning}>
            <Error
              message="This coach added application in college which is not
            in our system. Add college first by clicking college tab, once done add coach in that college using given email id."
            /></div> : '' }
      </div>
    </div>
  );
};

Application.propTypes = {
  item: PropTypes.shape.isRequired,
  handleApplicationUpgrade: PropTypes.func.isRequired,
  deleteCoachApplication: PropTypes.func.isRequired,
};

class CoachApplication extends Component {
  static propTypes = {
    getCoachApplications: PropTypes.func.isRequired,
    upgradeCoachApplication: PropTypes.func,
    coachApplicationRequested: PropTypes.bool.isRequired,
    coachApplications: PropTypes.shape(),
    applicationUpgradeRequested: PropTypes.bool.isRequired,
    deleteCoachApplication: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    coachApplications: {},
    upgradeCoachApplication: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
    this.handleApplicationUpgrade = this.handleApplicationUpgrade.bind(this);
  }
  componentWillMount() {
    if (this.props.coachApplications.size === 0) {
      const id = 1234;
      this.props.getCoachApplications(id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.applicationUpgradeRequested) {
      const id = 1234;
      this.props.getCoachApplications(id);
    }
  }

  handleApplicationUpgrade(id) {
    const payload = Object.assign({
      coach_id: id,
      application_status: 'VERIFIED',
    });
    this.props.upgradeCoachApplication(payload);
  }

  render() {
    const { deleteCoachApplication } = this.props;
    const renderLoader = renderIf(this.props.coachApplicationRequested
        || this.props.applicationUpgradeRequested);
    return (
      <div className={cn('col s12', styles.container)}>
        {renderLoader(
          <FullScreenLoader />,
          )}
        {this.props.coachApplications.map(item => (
          <Application
            item={item}
            deleteCoachApplication={() => deleteCoachApplication(item.get('coach_id'))}
            handleApplicationUpgrade={this.handleApplicationUpgrade}
          />
        ))}
      </div>
    );
  }
}

export default CoachApplication;



// WEBPACK FOOTER //
// ./src/components/CoachApplication/CoachApplication.js